import { Boundaries } from "@planzone/core";
import { State } from "./types";

function handleEditResourceGroup(
  state: State,
  group: Boundaries["editResourceGroup"]["success"],
): State {
  return state.map((res) => ({
    ...res,
    groups: res.groups.map((g) => (group.uuid === g.uuid ? group : g)),
  }));
}

export { handleEditResourceGroup };
